import React from 'react'
import { BarChart, CartesianGrid, Label, XAxis, YAxis, ResponsiveContainer } from 'recharts'
import PropTypes from 'prop-types'

import { chartMargins } from '../../../../utils/renderUtils'

const EmptyPlaceholderChart = props => {
  return (
    <ResponsiveContainer width="100%" aspect={4.0 / 3.0}>
      <BarChart width={props.width} height={props.height} margin={chartMargins}>
        <XAxis tick={false} ticks={[0]}>
          <Label value={props.xAxisLabel} position="insideBottom" offset={-3} />
        </XAxis>
        <CartesianGrid stroke="#f5f5f5" />
        <YAxis>
          <Label value={props.yAxisLabel} position="insideLeft" angle={-90} style={{ textAnchor: 'middle' }} />
        </YAxis>
      </BarChart>
    </ResponsiveContainer>
  )
}

EmptyPlaceholderChart.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  xAxisLabel: PropTypes.string,
  yAxisLabel: PropTypes.string
}

export default EmptyPlaceholderChart
